<template>

  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">Declaration des marches</h1>
      <div>
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'dashboard' }"><a>Tableau de
                bord</a></router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            <router-link :to="{ name: 'declarationMarche' }">Declaration des marches</router-link>
          </li>
        </ol>
      </div>
    </div>

    <div class="my-2">
      <router-link :to="{ name: 'pta',params: {  annee:anneeRoute } }"><a><i class="fe fe-arrow-left"></i>
          Retour</a></router-link>
    </div>

    <div class="modal fade" v-if="activite" id="modal-detail-activity" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-xl " role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h6 class="modal-title fw-bold" style="font-size: 16px;">Declaration des marches</h6><button
              aria-label="Close" class="btn-close text-white" data-bs-dismiss="modal" type="button"><span
                aria-hidden="true">×</span></button>
          </div>
          <div class="modal-body">
            <ul class="row p-3">
              <li class="col-lg-12 mb-2">
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="form-label">Année <span class="text-danger">*</span></label>
                      <multi-select disabled deselect-label="Sélectionné" select-label="" :options="exercices"
                        @select="loadActionsGrouped" placeholder="Sélectionné une année " label="annee" track-by="annee"
                        :searchable="true" :custom-label="o => o.annee" v-model="payload.exercice">
                        <template slot="singleLabel" slot-scope="{ option }">
                          <strong> {{ option.annee }}</strong>
                        </template>
                        <span slot="noOptions">
                          <strong>Liste Vide</strong>
                        </span>
                        <span slot="noResult">
                          <strong>Aucun Résultat</strong>
                        </span>
                      </multi-select>

                    </div>
                  </div>


                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="form-label">ID PTA Interne <span class="text-danger">*</span></label>
                      <input class="form-control mb-4" disabled v-model="activite.idPtaAsin" readonly="" type="text">

                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="form-label">Activité</label>
                      <input class="form-control mb-4" disabled v-model="activite.description" readonly="" type="text">

                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="form-label">Status Arbitrage <span class="text-danger">*</span></label>
                      <input class="form-control mb-4" disabled v-model="activite.statut" readonly="" type="text">

                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group m-0">
                      <label class="form-label">BESOINS</label>
                      <hr class="mt-2" style="border-top: 2px solid #ccc;">
                      <div class="row ">
                        <div class="col-6">
                          <label class="form-label">Total AE</label>
                          <AmountInput class="form-control border-dark " readonly v-model="activite.besoinAeTotTtc" />
                        </div>
                        <div class="col-6">
                          <label class="form-label">Total CP</label>
                          <AmountInput class="form-control border-dark " readonly v-model="activite.besoinCpTotTtc" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group m-0 text-center">
                      <label class="form-label">REPORTS</label>
                      <hr class="mt-2" style="border-top: 2px solid #ccc;">
                      <div class="row justify-content-center">
                        <div class="col-6">
                          <label class="form-label">Total :</label>
                          <AmountInput class="form-control border-dark " readonly
                            v-model="activite.reportMobiliseTot" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group m-0">
                      <label class="form-label">ALLOUEES</label>
                      <hr class="mt-2" style="border-top: 2px solid #ccc;">
                      <div class="row ">
                        <div class="col-6">
                          <label class="form-label">Total AE</label>
                          <AmountInput class="form-control border-dark " readonly v-model="activite.alloueAeTotTtc" />
                        </div>
                        <div class="col-6">
                          <label class="form-label">Total CP</label>
                          <AmountInput class="form-control border-dark " readonly v-model="activite.alloueCpTotTtc" />
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </li>

              <li class="col-lg-12 mb-2">
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title fw-bold">Informations du marche</h3>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group m-0">
                          <div class="row ">
                            <div class="col-6">
                              <label class="form-label">Methodologie souhaite</label>
                              <multi-select v-model="activite.idMethodMarche" deselect-label="Sélectionné"
                                select-label="" :options="methodologies" placeholder="Sélectionné le type"
                                label="libelle" track-by="idMethodMarche" :searchable="true">
                                <span slot="noOptions">
                                  <strong>Liste Vide</strong>
                                </span>
                                <span slot="noResult">
                                  <strong>Aucun Résultat</strong>
                                </span>
                              </multi-select>
                            </div>
                            <!-- <div class="col-6">
                                        <label class="form-label">Organe de controle</label>
                                        <select v-model="activite.organeControle" class="form-control">
                                            <option disabled value="">Sélectionnez</option>
                                            <option value="AMI">AMI</option>
                                            <option value="DP">DP</option>
                                        </select>
                                    </div> -->
                            <div class="col-6">
                              <label class="form-label">Durée estime :</label>
                              <input type="number" class="form-control" v-model="activite.dureeEstimMarche">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group m-0 text-center">
                          <div class="row">
                            <div class="col-6">
                              <label class="form-label">Date Prevue lancement :</label>
                              <input type="date" class="form-control" v-model="activite.datePrevuLancement">
                            </div>
                            <div class="col-6">
                              <label class="form-label">Date Prevue lancement au plus tard</label>
                              <input type="date" class="form-control" v-model="activite.dateLanceAuplustard">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group m-0">
                          <div class="row ">
                            <div class="col-6">
                              <label class="form-label">Date prevue contrat</label>
                              <input type="date" class="form-control" v-model="activite.datePrevueContrat">
                            </div>
                            <div class="col-6">
                              <label class="form-label">Eligible Marche</label>
                              <select v-model="activite.eligibleMarche" class="form-control">
                                <option disabled value="">Sélectionnez</option>
                                <option value="Oui">Oui</option>
                                <option value="Non">Non</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group m-0">
                          <div class="row ">
                            <div class="col-6">
                              <label class="form-label">Contrat Cadre</label>
                              <select v-model="activite.contratCadre" class="form-control">
                                <option disabled value="">Sélectionnez</option>
                                <option value="Oui">Oui</option>
                                <option value="Non">Non</option>
                              </select>
                            </div>
                            <div class="col-6">
                              <label class="form-label">Poids</label>
                              <input type="text" readonly class="form-control" v-model="activite.poids">
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="col-md-4">
                            <div class="form-group m-0 text-center">
                                <div class="row">
                                    <div class="col-6">
                                        <label class="form-label">Typologie Investissement :</label>
                                        <multi-select v-model="activite.typologie" deselect-label="Sélectionné" select-label="" :options="typologies"
                                                        placeholder="Sélectionné le type" label="typologie" track-by="typologie" :searchable="true">
                                            <span slot="noOptions">
                                                <strong>Liste Vide</strong>
                                            </span>
                                            <span slot="noResult">
                                                <strong>Aucun Résultat</strong>
                                            </span>
                                        </multi-select>
                                    </div>
                                    <div class="col-6">
                                        <label class="form-label">Mission Terrain PMO Hors budget :</label>
                                        <select v-model="activite.missionTerrainPmo" class="form-control">
                                            <option disabled value="">Sélectionnez</option>
                                            <option value="Oui">Oui</option>
                                            <option value="Non">Non</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                      <div class="col-md-4">
                        <div class="form-group m-0">
                          <div class="row ">
                            <!-- <div class="col-6">
                                    <label class="form-label">Tache de communication / Mission</label>
                                    <input type="text" class="form-control" v-model="activite.tacheCom">
                                </div> -->
                            <div class="col-6">
                              <label class="form-label">Source de financement</label>
                              <multi-select v-model="activite.sourceFinancement" deselect-label="Sélectionné"
                                select-label="" :options="sourcesFinancement" placeholder="Sélectionné la source"
                                label="sourceFinancement" track-by="sourceFinancement" :searchable="true">
                                <span slot="noOptions">
                                  <strong>Liste Vide</strong>
                                </span>
                                <span slot="noResult">
                                  <strong>Aucun Résultat</strong>
                                </span>
                              </multi-select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group m-0">
                          <div class="row ">
                            <!-- <div class="col-6">
                                        <label class="form-label">Beneficiaire</label>
                                        <input type="text" class="form-control" v-model="activite.beneficiaire">
                                    </div> -->
                          </div>
                        </div>
                      </div>
                      <!-- <div class="col-md-4">
                            <div class="form-group m-0 text-center">
                                <div class="row">
                                    <div class="col-6">
                                        <label class="form-label">Categorie :</label>
                                        <select v-model="activite.categorie" class="form-control">
                                            <option disabled value="">Sélectionner la categorie</option>
                                            <option value="Nouveau">Nouveau</option>
                                            <option value="Reconduite">Reconduite</option>
                                        </select>
                                    </div>
                                    <div class="col-6">
                                        <label class="form-label">Recurrent :</label>
                                        <select v-model="activite.recurrent" class="form-control">
                                            <option disabled value="">Sélectionnez</option>
                                            <option value="Oui">Oui</option>
                                            <option value="Non">Non</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>

                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button class="btn btn-success" @click="saveMarche">Enregistrer</button>
            <button class="btn btn-gray" data-bs-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" v-if="task" id="detail-task" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-xl w-100" style="max-width: 80%;" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h6 class="modal-title fw-bold" style="font-size: 16px;">DETAIL ARBITRAGE LIGNE DE PTA</h6>
            <button aria-label="Close" class="btn-close text-white" data-bs-dismiss="modal" type="button"><span
                aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="row p-3">
              <li class="col-lg-12 mb-2">
                <div class="row">
                  <div class="col-md-2">
                    <div class="form-group">
                      <label class="form-label">Année <span class="text-danger">*</span></label>
                      <multi-select disabled deselect-label="Sélectionné" select-label="" :options="exercices"
                        @select="loadActionsGrouped" placeholder="Sélectionné une année " label="annee" track-by="annee"
                        :searchable="true" :custom-label="o => o.annee" v-model="payload.exercice">
                        <template slot="singleLabel" slot-scope="{ option }">
                          <strong> {{ option.annee }}</strong>
                        </template>
                        <span slot="noOptions">
                          <strong>Liste Vide</strong>
                        </span>
                        <span slot="noResult">
                          <strong>Aucun Résultat</strong>
                        </span>
                      </multi-select>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <label class="form-label">ID PTA Interne <span class="text-danger">*</span></label>
                      <input class="form-control " v-model="task.idPtaAsin" readonly type="text">

                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="form-label">Activité</label>
                      <input class="form-control mb-4" v-model="activite.description" readonly="" type="text">

                    </div>
                  </div>

                  <div class="col-md-2">
                    <div class="form-group">
                      <label class="form-label">Date Debut <span class="text-danger">*</span></label>
                      <date-pick :language="fr" :bootstrapStyling="true" disabled minimumView="day" name="dateDebut"
                        v-model="task.dateDebut" placeholder="Sélectionnez la date de debut"
                        calendar-button-icon="fe fe-calendar" />

                    </div>
                  </div>

                  <div class="col-md-2">
                    <div class="form-group">
                      <label class="form-label">Date Fin <span class="text-danger">*</span></label>
                      <date-pick :language="fr" :bootstrapStyling="true" disabled minimumView="day" name="dateDebut"
                        v-model="task.dateFin" placeholder="Sélectionnez la date de Fin"
                        calendar-button-icon="fe fe-calendar" />

                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group m-0 text-center">
                      <label class="form-label">REPORTS</label>
                      <hr class="mt-1" style="border-top: 2px solid #ccc;">
                      <br><br>
                      <div class="row  mb-1">
                        <div class="justify-content-center">
                          <div class="col-12">
                            <div class="d-flex flex-column align-items-center">
                              <label class="form-label">BN</label>
                              <AmountInput class="form-control border-dark w-50" v-model="task.reportBnTtc" />
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="d-flex flex-column align-items-center">
                              <label class="form-label">PRET</label>
                              <AmountInput class="form-control border-dark w-50" v-model="task.reportPretTtc" />
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="d-flex flex-column align-items-center">
                              <label class="form-label">DON</label>
                              <AmountInput class="form-control border-dark w-50" v-model="task.reportDonTtc" />
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="d-flex flex-column align-items-center">
                              <label class="form-label">ANT</label>
                              <AmountInput class="form-control border-dark w-50" v-model="task.reportAntTtc" />
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="d-flex flex-column align-items-center">
                              <label class="form-label">BA</label>
                              <AmountInput class="form-control border-dark w-50" v-model="task.reportBaTtc" />
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="d-flex flex-column align-items-center">
                              <label class="form-label">TOTAL Report :</label>

                              <AmountInput class="form-control border-dark w-50" readonly :value="reportMobiliseTot" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group m-0">
                      <label class="form-label">BESOINS</label>
                      <hr class="mt-1" style="border-top: 2px solid #ccc;">

                      <div class="row ">
                        <div class="col-md-12">
                          <div class="row ">
                            <div class="col-6">
                              <label class="form-label">Autorisation d'engagement</label>
                              <hr class="mt-1" style="border-top: 2px solid #ccc;">
                              <div class="col-12">
                                <label class="form-label">BN</label>
                                <AmountInput class="form-control border-dark" v-model="task.besoinAeBnTtc" />
                              </div>
                              <div class="col-12">
                                <label class="form-label">PRET</label>
                                <AmountInput class="form-control border-dark" v-model="task.besoinAePretTtc" />
                              </div>
                              <div class="col-12">
                                <label class="form-label">DON</label>
                                <AmountInput class="form-control border-dark" v-model="task.besoinAeDonTtc" />
                              </div>
                              <div class="col-12">
                                <label class="form-label">ANT</label>
                                <AmountInput class="form-control border-dark" v-model="task.besoinAeAntTtc" />
                              </div>

                              <div class="col-12">
                                <label class="form-label">BA</label>
                                <AmountInput class="form-control border-dark" v-model="task.besoinAeBaTtc" />
                              </div>
                              <div class="col-12">
                                <label class="form-label">TOTAL AE</label>
                                <AmountInput class="form-control border-dark" readonly :value="besoinAeTotTtc" />
                              </div>

                            </div>
                            <div class="col-6">
                              <label class="form-label">Crédit de paiement</label>
                              <hr class="mt-1" style="border-top: 2px solid #ccc;">
                              <div class="col-12">
                                <label class="form-label">BN</label>
                                <AmountInput class="form-control border-dark" v-model="task.besoinCpBnTtc" />
                              </div>
                              <div class="col-12">
                                <label class="form-label">PRET</label>
                                <AmountInput class="form-control border-dark" v-model="task.besoinCpPretTtc" />
                              </div>
                              <div class="col-12">
                                <label class="form-label">DON</label>
                                <AmountInput class="form-control border-dark " v-model="task.besoinCpDonTtc" />
                              </div>
                              <div class="col-12">
                                <label class="form-label">ANT</label>
                                <AmountInput class="form-control border-dark " v-model="task.besoinCpAntTtc" />
                              </div>

                              <div class="col-12">
                                <label class="form-label">BA</label>
                                <AmountInput class="form-control border-dark " v-model="task.besoinCpBaTtc" />
                              </div>
                              <div class="col-12">
                                <label class="form-label">TOTAL CP</label>
                                <AmountInput class="form-control border-dark " readonly :value="besoinCpTotTtc" />
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group m-0">
                      <label class="form-label">ALLOUES</label>
                      <hr class="mt-1" style="border-top: 2px solid #ccc;">
                      <div class="row ">
                        <div class="col-md-12">
                          <div class="row ">
                            <div class="col-6">
                              <label class="form-label">Autorisation d'engagement</label>
                              <hr class="mt-1" style="border-top: 2px solid #ccc;">
                              <div class="col-12">
                                <label class="form-label">BN</label>
                                <AmountInput class="form-control border-dark " v-model="task.alloueAeBnTtc" />
                              </div>
                              <div class="col-12">
                                <label class="form-label">PRET</label>
                                <AmountInput class="form-control border-dark " v-model="task.alloueAePretTtc" />
                              </div>
                              <div class="col-12">
                                <label class="form-label">DON</label>
                                <AmountInput class="form-control border-dark " v-model="task.alloueAeDonTtc" />
                              </div>
                              <div class="col-12">
                                <label class="form-label">ANT</label>
                                <AmountInput class="form-control border-dark " v-model="task.alloueAeAnTtc" />
                              </div>

                              <div class="col-12">
                                <label class="form-label">BA</label>
                                <AmountInput class="form-control border-dark " v-model="task.alloueAeBaTtc" />
                              </div>
                              <div class="col-12">
                                <label class="form-label">TOTAL AE</label>
                                <AmountInput class="form-control border-dark " readonly :value="alloueAeTotTtc" />
                              </div>

                            </div>
                            <div class="col-6">
                              <label class="form-label">Crédit de paiement</label>
                              <hr class="mt-1" style="border-top: 2px solid #ccc;">
                              <div class="col-12">
                                <label class="form-label">BN</label>
                                <AmountInput class="form-control border-dark " v-model="task.alloueCpBnTtc" />
                              </div>
                              <div class="col-12">
                                <label class="form-label">PRET</label>
                                <AmountInput class="form-control border-dark " v-model="task.alloueCpPretTtc" />
                              </div>
                              <div class="col-12">
                                <label class="form-label">DON</label>
                                <AmountInput class="form-control border-dark " v-model="task.alloueCpBnTtc" />
                              </div>
                              <div class="col-12">
                                <label class="form-label">ANT</label>
                                <AmountInput class="form-control border-dark " v-model="task.alloueCpAnTtc" />
                              </div>

                              <div class="col-12">
                                <label class="form-label">BA</label>
                                <AmountInput class="form-control border-dark " v-model="task.alloueCpBaTtc" />
                              </div>
                              <div class="col-12">
                                <label class="form-label">TOTAL CP</label>
                                <AmountInput class="form-control border-dark " readonly :model-value="alloueCpTotTtc" />
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr class="mt-2" style="border-top: 2px solid #ccc;">
                  <div class="col-md-12">
                    <div class="form-group m-0">
                      <div class="row ">
                        <div class="col-4">
                          <div class="form-group">
                            <div class="form-floating floating-label1">
                              <textarea class="form-control" v-model="task.commentaire" placeholder="Comments"
                                id="floatingTextarea2" style="height: 100px"></textarea>
                              <label for="floatingTextarea2">Comments</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-4">
                          <label class="form-label">Statut Arbitrage <span class="text-danger">*</span></label>
                          <multi-select deselect-label="Sélectionné" select-label="" :options="statutArbitrages"
                            placeholder="Sélectionné le Statut " label="statut" track-by="idStatutArb"
                            :searchable="true" :custom-label="o => o.libStatutArb" v-model="obStatutArbitrage">
                            <template slot="singleLabel" slot-scope="{ option }">
                              <strong> {{ option.libStatutArb }}</strong>
                            </template>
                            <span slot="noOptions">
                              <strong>Liste Vide</strong>
                            </span>
                            <span slot="noResult">
                              <strong>Aucun Résultat</strong>
                            </span>
                          </multi-select>
                        </div>

                        <div class="col-4 d-flex align-items-center">
                          <button class="btn btn-primary ms-auto" @click="saved(task)">Enregistrer Arbitrage</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr class="mt-2" style="border-top: 2px solid #ccc;">
                </div>
              </li>

              <li class="col-lg-12 mb-2">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="card">
                      <div class="card-header">
                        <h3 class="card-title justify-content-center">Historique de l'Arbitrage</h3>
                      </div>
                      <div class="card-body">
                        <div class="table-responsive">
                          <table class="table table-hover table-bordered">
                            <thead class="border-top success02">
                              <tr>
                                <th class="fw-bold">ID</th>
                                <th class="fw-bold">Statut Arbitrage </th>
                                <th class="fw-bold">Report </th>
                                <th class="fw-bold">Besoins AE</th>
                                <th class="fw-bold">Besoins CP</th>
                                <th class="fw-bold">Allocations AE</th>
                                <th class="fw-bold">Allocations CP</th>
                                <th class="fw-bold">Commentaire</th>
                                <th class="fw-bold">Date Arbitrage </th>
                                <th class="fw-bold">Auteur </th>
                              </tr>
                            </thead>
                            <tbody v-if="lastRecordArbitrage.length > 0">
                              <tr v-for="(arbitrage, index) in lastRecordArbitrage" :key="index" class="border-bottom">
                                <td>{{ arbitrage.id }}</td>
                                <td>{{ arbitrage.idStatutArb?.idStatutArb }} - {{ arbitrage.idStatutArb?.libStatutArb }}
                                </td>
                                <td class="text-end">{{ arbitrage.report.toLocaleString('fr-FR') }}</td>
                                <td class="text-end">{{ arbitrage.besoinAe.toLocaleString('fr-FR') }}</td>
                                <td class="text-end">{{ arbitrage.besoinCp.toLocaleString('fr-FR') }}</td>
                                <td class="text-end">{{ arbitrage.allocationAe.toLocaleString('fr-FR') }}</td>
                                <td class="text-end">{{ arbitrage.allocationCp.toLocaleString('fr-FR') }}</td>
                                <td>{{ arbitrage.commentaire }}</td>
                                <td>{{ formatDate(arbitrage.dateMaj, 'long') }}</td>
                                <td>{{ arbitrage.auteur }}</td>

                              </tr>
                            </tbody>
                            <tbody v-else>
                              <tr class="primary02">
                                <td colspan="10" class="text-center">Aucune Historique trouvée</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button class="btn btn-gray" data-bs-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-12 col-sm-12" v-if="showList">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label">Année <span class="text-danger">*</span></label>
                  <multi-select deselect-label="Sélectionné" select-label="" :options="exercices"
                    @select="loadActionsGrouped" placeholder="Sélectionné une année " label="annee" track-by="annee"
                    :searchable="true" :custom-label="o => o.annee" v-model="payload.exercice">
                    <template slot="singleLabel" slot-scope="{ option }">
                      <strong> {{ option.annee }}</strong>
                    </template>
                    <span slot="noOptions">
                      <strong>Liste Vide</strong>
                    </span>
                    <span slot="noResult">
                      <strong>Aucun Résultat</strong>
                    </span>
                  </multi-select>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card" v-if="allActionsGrouped.length > 0">
          <div class="card-header">
            <h3 class="card-title fw-bold">PTA de {{ payload.exercice.annee }}
            </h3>
          </div>
          <div class="card-body">
            <div class="my-2">
              <button class="btn btn-info text-start" @click="toggleAll">
                <span :class="allExpanded ? 'fe fe-minus' : 'fe fe-plus'"></span>
                {{ allExpanded ? 'Replier' : 'Déplier' }}
              </button>
              <p class="text-end">(En miliers FCFA TTC)</p>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-hover table-bordered text-nowrap mb-0">
                    <thead class="border-top success02">
                      <tr>
                        <th>Action</th>
                        <th></th>
                        <th>ID PTA interne</th>
                        <th>Description</th>
                        <th>Date Début</th>
                        <th>Date Fin</th>
                        <th>Besoin AE</th>
                        <th>Besoin CP</th>
                        <th>Report</th>
                        <th>Status Cadrage</th>
                        <th>Status Arbitrage</th>
                      </tr>
                    </thead>



                    <template v-for="(action, aIndex) in allActionsGrouped">
                      <tbody :key="'a-' + aIndex">
                        <tr class="bg-primary-transparent" style="cursor: pointer;"
                          @click="toggleCollapse('action', aIndex)">
                          <td class="ps-7 "></td>
                          <td class="ps-1">
                            <i :class="isCollapsed('action', aIndex) ? 'fe fe-minus' : 'fe fe-plus'"></i>
                            {{ action.libelleAction }}
                          </td>
                          <td colspan="10"></td>
                        </tr>
                      </tbody>


                      <tbody v-show="isCollapsed('action', aIndex)" v-for="(projet, pIndex) in action.projetPags"
                        :key="'p-' + aIndex + '-' + pIndex">
                        <tr class="bg-secondary-transparent " style="cursor: pointer;"
                          @click.stop="toggleCollapse('projet', aIndex + '-' + pIndex)">
                          <td class="ps-7 "></td>
                          <td class="ps-7 ">
                            <i :class="isCollapsed('projet', aIndex + '-' + pIndex) ? 'fe fe-minus' : 'fe fe-plus'"></i>
                            {{ projet.nomProjetPag }}
                          </td>
                          <td colspan="10"></td>
                        </tr>


                        <template v-if="isCollapsed('projet', aIndex + '-' + pIndex)">
                          <template v-for="(dc, actIndex) in projet.detailsComposantes">
                            <tr class="bg-success-transparent" :key="'act-' + aIndex + '-' + pIndex + '-' + actIndex"
                              style="cursor: pointer;"
                              @click.stop="toggleCollapse('activite', aIndex + '-' + pIndex + '-' + actIndex)">
                              <td class="text-center">
                                <div class="g-2">
                                  <button class="btn text-primary btn-sm" @click.prevent="displayActivity(dc.activite)"
                                    data-bs-toggle="tooltip" title="Declarer un marche"
                                    data-bs-original-title="Declarer un marche"><span
                                      class="fe fe-file-text fs-18"></span></button>

                                </div>
                              </td>
                              <td class="ps-5"></td>
                              <td><i
                                  :class="isCollapsed('activite', aIndex + '-' + pIndex + '-' + actIndex) ? 'fe fe-minus' : 'fe fe-plus'"></i>
                                {{ dc.activite.idPtaAsin }}
                              </td>
                              <td class="ps-1">{{ dc.activite.description }}</td>
                              <td>{{ formatDate(dc.activite.dateDebut) }}</td>
                              <td>{{ formatDate(dc.activite.dateFin) }}</td>
                              <td class="text-end">{{ dc.activite.besoinAeTotTtc.toLocaleString('fr-FR') }}</td>
                              <td class="text-end">{{ dc.activite.besoinCpTotTtc.toLocaleString('fr-FR') }}</td>
                              <td class="text-end">{{ dc.activite.reportMobiliseTot.toLocaleString('fr-FR') }}</td>
                              <td>{{ dc.activite.cadrage }}</td>
                              <td>{{ dc.activite.arbitrage }}</td>
                            </tr>


                            <template v-if="isCollapsed('activite', aIndex + '-' + pIndex + '-' + actIndex)">
                              <tr v-for="(tache, tIndex) in dc.activite.taches"
                                :key="'t-' + aIndex + '-' + pIndex + '-' + actIndex + '-' + tIndex">
                                <td class="text-center">
                                  <div class="g-2">
                                    <button class="btn text-primary btn-sm"
                                      @click.prevent="displayActivity(dc.activite)" data-bs-toggle="tooltip"
                                      title="Declarer un marche" data-bs-original-title="Declarer un marche"><span
                                        class="fe fe-file-text fs-18"></span></button>

                                  </div>
                                </td>
                                <td></td>
                                <td class="ps-10 text-end">{{ tache.idPtaAsin }}</td>
                                <td class="ps-7">{{ tache.description }}</td>
                                <td>{{ formatDate(tache.dateDebut) }}</td>
                                <td>{{ formatDate(tache.dateFin) }}</td>
                                <td class="text-end">{{ tache.besoinAeTotTtc.toLocaleString('fr-FR') }}</td>
                                <td class="text-end">{{ tache.besoinCpTotTtc.toLocaleString('fr-FR') }}</td>
                                <td class="text-end">{{ tache.reportMobiliseTot.toLocaleString('fr-FR') }}</td>
                                <td>{{ tache.cadrage }}</td>
                                <td>{{ tache.arbitrage }}</td>
                              </tr>
                            </template>
                          </template>
                        </template>
                      </tbody>
                    </template>
                  </table>

                </div>
              </div>
            </div>


          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
//import $ from 'jquery';
import { mapGetters, mapActions } from 'vuex';
import * as lang from "vuejs-datepicker/src/locale";
import AmountInput from "../../components/AmountInput.vue";

export default {
  name: "ArbitragePta",
  components: { AmountInput },
  data() {
    return {
      lang: lang,
      marche: {},anneeRoute:'',
      payload: { currentStep: 1, classeur: null, composante: "" },
      pta: {
        annee: "",
        dateDebut: "",
        dateFin: "",
        description: "",
        besoinAeBnTtc: 0,
        besoinAePretTtc: 0,
        besoinAeDonTtc: 0,
        besoinAeAntTtc: 0,
        besoinAeBaTtc: 0,
        besoinAeTotTtc: 0,
        besoin_cp_bn_ttc: 0,
        besoinCpPretTtc: 0,
        besoinCpDonTtc: 0,
        besoinCpAntTtc: 0,
        besoinCpBaTtc: 0,
        besoinCpTotTtc: 0
      },
      save: true,
      showList: true,
      notModified: false,
      choixCompo: false,
      choixAnnee: false,
      classeurs: [],
      composantes: [],
      exercices: [],
      obStatutArbitrage: {
        idStatutArb: "0.0",
        libStatutArb: "A faire"
      },
      statutArbitrages: [],
      typologies: [],
      methodologies: [],
      sourcesFinancement: [],
      lesactivites: [],
      lestaches: [],
      ptas: [],
      activite: null,
      task: null,
      allActionsGrouped: [],
      collapsedRows: {},
      lastRecordArbitrage: [],
      allExpanded: false,
    }
  },
  computed: {
    ...mapGetters({ items: 'generationPta' }),
    filtersItems() {
      return this.items || [];
    },
    fr() {
      return this.lang.fr;
    },
    besoinAeTotTtc() {
      const t = this.task;
      return (Number(t.besoinAeBnTtc) || 0)
        + (Number(t.besoinAeAntTtc) || 0)
        + (Number(t.besoinAePretTtc) || 0)
        + (Number(t.besoinAeBaTtc) || 0)
        + (Number(t.besoinAeDonTtc) || 0);
    },

    besoinCpTotTtc() {
      const t = this.task;
      return (Number(t.besoinCpBnTtc) || 0)
        + (Number(t.besoinCpAntTtc) || 0)
        + (Number(t.besoinCpPretTtc) || 0)
        + (Number(t.besoinCpBaTtc) || 0)
        + (Number(t.besoinCpDonTtc) || 0);
    },

    alloueAeTotTtc() {
      const t = this.task;
      return (Number(t.alloueAeBnTtc) || 0)
        + (Number(t.alloueAeAnTtc) || 0)
        + (Number(t.alloueAePretTtc) || 0)
        + (Number(t.alloueAeBaTtc) || 0)
        + (Number(t.alloueAeDonTtc) || 0);
    },

    alloueCpTotTtc() {
      const t = this.task;
      return (Number(t.alloueCpBnTtc) || 0)
        + (Number(t.alloueCpAnTtc) || 0)
        + (Number(t.alloueCpPretTtc) || 0)
        + (Number(t.alloueCpBaTtc) || 0)
        + (Number(t.alloueCpDonTtc) || 0);
    },
    reportMobiliseTot() {
      const t = this.task;
      const bn = Number(t.reportBnTtc) || 0;
      const pret = Number(t.reportPretTtc) || 0;
      const ant = Number(t.reportAntTtc) || 0;
      const ba = Number(t.reportBaTtc) || 0;
      const don = Number(t.reportDonTtc) || 0;

      console.log('Recomputing total:', t.reportBnTtc, t.reportPretTtc);

      return bn + pret + ant + ba + don;
    },
    totalBesoinAETotal() {
      return this.lestaches.reduce((acc, tache) => {
        return acc + this.totalBesoinAE(tache);
      }, 0);
    },
    totalBesoinCPTotal() {
      return this.lestaches.reduce((acc, tache) => {
        return acc + this.totalBesoinCP(tache);
      }, 0);
    },
    totalAlloueAETotal() {
      return this.lestaches.reduce((acc, tache) => {
        return acc + this.totalAlloueAE(tache);
      }, 0);
    },
    totalAlloueCPTotal() {
      return this.lestaches.reduce((acc, tache) => {
        return acc + this.totalAlloueCP(tache);
      }, 0);
    },
    reportTotal() {
      return this.lestaches.reduce((acc, tache) => {
        return acc + this.totalReport(tache);
      }, 0);
    }
  },
  watch: {
    imported: {
      immediate: true,
      handler(val) {
        if (val) this.payload.currentStep++;
      },
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions('generationPta', ['all', 'add']),
    async reloadModalData(task) {
      this.$loading(true);
      const { data } = await this.$http.get(`/pta/parent/all/${task.idDetailParent}`);
      this.lestaches = data;

      const { data: activ } = await this.$http.get(`/pta/${task.idActivite}`);
      this.activite = activ;

      this.loadActionsGrouped();


    },
    toggleCollapse(type, index) {
      const key = `${type}-${index}`;
      this.$set(this.collapsedRows, key, !this.collapsedRows[key]);
    },
    isCollapsed(type, index) {
      const key = `${type}-${index}`;
      return this.collapsedRows[key];
    },
    toggleAll() {
      this.allExpanded = !this.allExpanded;

      this.allActionsGrouped.forEach((action, aIndex) => {
        const actionKey = `action-${aIndex}`;
        this.$set(this.collapsedRows, actionKey, this.allExpanded);

        action.projetPags.forEach((projet, pIndex) => {
          const projetKey = `projet-${aIndex + '-' + pIndex}`;
          this.$set(this.collapsedRows, projetKey, this.allExpanded);

          projet.detailsComposantes.forEach((activite, actIndex) => {
            const activiteKey = `activite-${aIndex + '-' + pIndex + '-' + actIndex}`;
            this.$set(this.collapsedRows, activiteKey, this.allExpanded);
          });

        });


      });
    },
    saveMarche() {
      this.$loading(true);
      this.$http.put('/pta/declarer/marche/' + this.activite.id, this.activite)
        .then(async ({ data }) => {
          swal('Information!', 'Marche declare avec succès.', 'success');
          $('#modal-detail-activity').modal('hide');
        })
        .catch((error) => {
          swal('Information!', 'Une erreur est survenue lors de la declaration. ' + error, 'warning');
        })
        .finally(() => this.$loading(false));
    },
    async displayActivity(item) {
      this.$loading(true);
      try {
        await this.getPta(item.id);
        $('#modal-detail-activity').modal('show');
      } catch (error) {
        console.error('Erreur dans displayActivity:', error);
      } finally {
        this.$loading(false);
      }
    },
    async editTask(item, active) {
      this.$loading(true);

      try {
        this.activite = active;
        await this.getOnePta(item.id, "tache");

        await this.loadHistoryArbitrage(item);

        $('#detail-task').modal('show');
      } catch (error) {
        console.error('Erreur dans edit task:', error);
      } finally {
        this.$loading(false);
      }
    },
    totalBesoinAE(item) {
      return (
        item.besoinAeAntTtc +
        item.besoinAeBaTtc +
        item.besoinAeBnTtc +
        item.besoinAeDonTtc +
        item.besoinAePretTtc
      )
    },
    totalBesoinCP(item) {
      return (
        item.besoinCpAntTtc +
        item.besoinCpBaTtc +
        item.besoinCpBnTtc +
        item.besoinCpDonTtc +
        item.besoinCpPretTtc
      )
    },
    totalAlloueCP(item) {
      return (
        item.alloueCpAnTtc +
        item.alloueCpBaTtc +
        item.alloueCpBnTtc +
        item.alloueCpDonTtc +
        item.alloueCpPretTtc
      )
    },
    totalAlloueAE(item) {
      return (
        item.alloueAeAnTtc +
        item.alloueAeBaTtc +
        item.alloueAeBnTtc +
        item.alloueAeDonTtc +
        item.alloueAePretTtc
      )
    },
    totalReport(item) {
      return (
        Number(item.reportAntTtc)
        + Number(item.reportBaTtc)
        + Number(item.reportBnTtc)
        + Number(item.reportDonTtc)
        + Number(item.reportPretTtc)
      )
    },
    isEmpty(value) {
      return value === null || value === '' || (typeof value === 'object' && Object.keys(value).length === 0);
    },
    onSearch(offset) {
      this.$loading(true);
      if (offset > 0) this.option.page = offset - 1;
      this.$router.push({ query: this.option }).catch(() => {
      });
      this.getExercices();
      this.getClasseurs();
      this.getStatutArbitrage();
    },
    isValidMontants() {
      const totalAlloueAe = this.alloueAeTotTtc;
      const totalAlloueCp = this.alloueCpTotTtc;
      const totalBesoinCp = this.besoinCpTotTtc;
      const totalBesoinAe = this.besoinAeTotTtc;

      const allPositive = totalAlloueAe >= 0 && totalAlloueCp >= 0 && totalBesoinAe >= 0 && totalBesoinCp >= 0;

      return allPositive > 0;
    },
    loadHistoryArbitrage(task) {
      return this.$http.get(`/arbitragePta/pta/${task.id}`)
        .then(({ data }) => {
          console.log("darrrrr", data);
          this.lastRecordArbitrage = data;
        })
        .catch(err => {
          console.error("Erreur getDetailComposant:", err);
          throw err;
        });
    },

    getAllPtaByDetailComposant(id) {
      return this.$http.get(`/pta/parent/all/${id}`)
        .then(({ data }) => {
          this.lestaches = data;
        })
        .catch(err => {
          console.error("Erreur getAllPtaByDetailComposant:", err);
          throw err;
        });
    },
    getPta(id) {
      return this.$http.get(`/pta/${id}`)
        .then(({ data }) => {
          this.activite = data;
        })
        .catch(err => {
          console.error("Erreur getPta:", err);
          throw err;
        });
    },
    getOnePta(id, type) {
      return this.$http.get(`/pta/${id}`)
        .then(({ data }) => {
          if (type === "tache") {
            this.task = data;
          } else {
            this.activite = data;
          }
        })
        .catch(err => {
          console.error("Erreur getPta:", err);
          throw err;
        });
    },
    saved(task) {
      this.$loading(true);
      if (!this.isValidMontants()) {
        swal('Information!', "Tous les montants doivent être positifs");
        this.$loading(false);
        return;
      }
      if (task.commentaire === '' || task.commentaire == null) {
        swal('Information!', "Veillez entrer un commentaire");
        this.$loading(false);
        return;
      }
      if (this.obStatutArbitrage === '' || this.obStatutArbitrage == null || this.obStatutArbitrage.idStatutArb === "0.0") {
        swal('Information!', "Veillez selectionner le statut");
        this.$loading(false);
        return;
      }
      if (this.save) {
        task.besoinAe = this.besoinAeTotTtc
        task.besoinCp = this.besoinCpTotTtc
        task.allocationAe = this.alloueAeTotTtc
        task.allocationCp = this.alloueCpTotTtc
        task.report = this.reportMobiliseTot
        task.idPta = task.idPta || {};
        task.idPta.id = task.id;
        task.idStatutArb = this.obStatutArbitrage;
        task.idActivite = this.activite.id;
        this.task = task;
        this.$loading(true);
        this.$http.post('/arbitragePta/with-request', task)
          .then(async ({ data }) => {
            await this.loadHistoryArbitrage(task);

            await this.reloadModalData(task);

            task.commentaire = ""
            this.obStatutArbitrage = {
              idStatutArb: "0.0",
              libStatutArb: "A faire"
            }

            this.$loading(false)
            swal('Information!', 'Sauvegarde  effectué avec succès.', 'success');

          })
          .catch((error) => {
            swal('Information!', 'Une erreur est survenue lors de la sauvegarde. ' + error, 'warning');
          })
          .finally(() => this.$loading(false));
      }


    },
    cadrage() {
      console.log(this.ptas);
    },
    getClasseurs() {
      this.$http.get('/classeurs/all')
        .then(({ data }) => {
          console.log(data);
          console.log(1);
          this.classeurs = data;
          this.$loading(false);
        });


    },

    getExercices() {
      this.$http.get('/exercice')
        .then(({ data }) => {
          console.log(data);
          console.log(1);
          this.exercices = data;

        });
    },
    getStatutArbitrage() {
      this.$http.get('/statutArbitrage')
        .then(({ data }) => {
          console.log(data);
          console.log(1);
          this.statutArbitrages = data;

        });
    },

    loadActionsGrouped() {
      this.$loading(true);
      this.$http.get(`/search/actions/${this.payload.exercice.annee}`)
        .then(({ data }) => {
          console.log(data);
          this.choixAnnee = true;
          this.allActionsGrouped = data;
          this.$loading(false);
        });
    },
    formatDate(dateStr, mode = 'court') {
      const date = new Date(dateStr);

      const optionsLong = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      };

      const optionsCourt = {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
      };

      const options = mode === 'long' ? optionsLong : optionsCourt;

      return date.toLocaleString('fr-FR', options);
    },
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1) + min);
    }

  },
  created() {
this.anneeRoute = this.$route.params.annee;
    this.onSearch()
    this.getExercices()
    this.getStatutArbitrage()
    this.$http.get('/typologiePta')
      .then(({ data }) => {
        this.typologies = data;
      });

    this.$http.get('/methodologieMarche')
      .then(({ data }) => {
        this.methodologies = data;
      });

    this.$http.get('/sourceFinancement')
      .then(({ data }) => {
        this.sourcesFinancement = data;
      });


  },
}
</script>

<style>
.loading-screen {
  z-index: 9999999999999 !important;
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>